let PackagesItem = [
    // {
    //     track: 'Junior',
    //     trackJunior: true,
    //     trackTitle: "Previous event",
    //     trackSubtitle: "2023 Recordings",
    //     trackPrice: "49",
    //     runningString: true,
    //     trackButton: "Register",
    //     trackLink: 'https://geekle.us/ticket/1689231633899x172202488554586100',
    //     // juniorTicket1Name: "Free Ticket",
    //     // juniorTicket1Price: "0.00",
    //     // juniorTicket1Link: "https://geekle.us/ticketfree/1696332788820x284523234900574200",
    //     // juniorTicket2Name: "+ Certificate",
    //     // juniorTicket2Price: "9.99",
    //     // juniorTicket2Link: "https://geekle.us/ticket/1705574856474x599972886754361300",
    //     // juniorTicket3Name: "+ Certificate & Recordings",
    //     // juniorTicket3Price: "15.99",
    //     // juniorTicket3Link: "https://geekle.us/ticket/1705574783431x842025016561500200",
    // },
    {
        track: 'Junior',
        trackJunior: true,
        trackRecording: true,
        trackTitle: "Recordings only",
        trackSubtitle: "ticket",
        trackPrice: "59",
        runningString: true,
        trackButton: "Register",
        trackLink: 'https://geekle.us/ticket/1717323174455x251054310012485630',
    },
    {
        track: 'Full Access',
        trackFull: true,
        trackTitle: "FULL ACCESS 🔥",
        trackSubtitle: "Early bird ticket",
        runningString: true,
        trackFullPrice: "99",
        trackPrice: "39",
        earlyBird: "early birds price",
        trackDesc: "1",
        trackButton: "Register",
        trackList1: 'Part 3 access(September 17)',
        trackList2: 'Part 4 access(December 3)',
        trackLink: 'https://geekle.us/ticket/1696332693483x103208367200141310',
    },
    {
        track: 'Full Access',
        trackJunior: true,
        trackWorkshop: true,
        trackTitle: "Workshop 🎓",
        trackSubtitle: "TOOLBOX AND BEST PRACTICES TO BUILD AI-ENABLED PRODUCTS",
        runningString: true,
        trackPrice: "299",
        earlyBird: "early birds price",
        trackDesc: "1",
        trackButton: "Register",
        trackList1: 'Junior and Senior Track Access',
        trackLink: 'https://events.geekle.us/workshops/slavahanzin/',
    },
    // {
    //     track: 'Full Access',
    //     trackJunior: true,
    //     trackWorkshop: true,
    //     trackWorkshopCombo: true,
    //     trackTitle: "Combo",
    //     trackSubtitle: "Workshop + Full Access ticket",
    //     runningString: true,
    //     trackPrice: "499",
    //     earlyBird: "early birds price",
    //     trackDesc: "1",
    //     trackButton: "Register",
    //     trackList1: 'Junior and Senior Track Access',
    //     trackLink: 'https://events.geekle.us/workshops/slavahanzin/',
    // },
    // {
    //     track: 'Full Access',
    //     trackFull: true,
    //     trackCombo: true,
    //     trackTitle: "Combo",
    //     trackSubtitle: "Previous + Full Access ticket",
    //     runningString: true,
    //     trackPrice: "179",
    //     earlyBird: "early birds price",
    //     trackDesc: "1",
    //     trackButton: "Register",
    //     trackList1: 'Junior and Senior Track Access',
    //     trackLink: 'https://geekle.us/ticket/1706015249832x651049662908465200',
    // },
    {
        track: 'Year',
        trackTitle: "YEAR OF AI ❤️",
        trackSubtitle: "package",
        runningString: true,
        trackFullPrice: "199",
        trackPrice: "75",
        earlyBird: "one year access",
        trackDesc: "1",
        trackText: true,
        yearTrackText: true,
        trackText1: "One Year Package",
        trackButton: "Register",
        trackLink: 'https://geekle.us/ticket/1717326431514x422726895475884000',
    },
    {
        track: 'Premium',
        newPremium: true,
        trackTitle: "GEEKLE PREMIUM",
        trackSubtitle: "MEMBERSHIP",
        trackPriceApperance: 2,
        trackFullPrice: "399",
        trackPrice: "199",
        trackText: true,
        trackText1: "One Year Premium Membership",
        trackDesc: "1",
        trackButton: "BUY",
        trackLink: 'https://geekle.us/ticket/1717067245361x673782170367819800',
        inverseColors: true,
    },
    // {
    //     trackTitle: "TEAM-5",
    //     trackSubtitle: "YEAR GROUP PACKAGE",
    //     trackPriceApperance: 3,
    //     runningString: true,
    //     trackPrice: "999",
    //     trackText: true,
    //     trackText1: "One Year Pass for 5 team members",
    //     trackDesc: "1",
    //     trackButton: "BUY",
    //     trackLink: 'https://geekle.us/ticket/1694109810106x843614570263085000',
    // },
    {
        track: 'Unlimited',
        trackTitle: "UNLIMITED",
        trackSubtitle: "YEAR ENTERPRISE PACKAGE",
        trackPriceApperance: 4,
        runningString: true,
        trackPrice: "Ask Our Manager",
        trackText: true,
        trackText1: "One Year Pass for up to 100 members",
        trackDesc: "1",
        trackButton: "Get Offer",
        trackLink: 'enterprise',
        validDate: '9.06',
    },
];

export default PackagesItem;
